import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import DateTableCell from './DateTableCell';

const useStyles = makeStyles(theme => ({
  rootGrow: {
    width: '100%',
    overflowX: 'auto',
    height: '100%'
  },
  table: {
    minWidth: 500
  },
  tableWrapper: {
    maxHeight: 300
  },
  header: {
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    textTransform: 'uppercase'
  },
  cell: {
    fontSize: theme.typography.fontSize - 2,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  rootNoGrow: {
    width: '100%',
    overflowX: 'auto',
    height: '100%',
    flexGrow: 1
  }
}));

const convertValueToCell = (val, type) => {
  if (type === 'date') {
    return <DateTableCell date={val} />;
  } else if (type === 'array') {
    return val.join(', ');
  }
  return val;
};

const DispatchSimpleTable = ({ grow, rows, title }) => {
  const CLASSES = useStyles();
  const GROW_CLASS = grow ? CLASSES.rootGrow : CLASSES.rootNoGrow;

  return (
    <Paper className={GROW_CLASS}>
      <div className={CLASSES.tableWrapper}>
        <Table className={CLASSES.table}>
          <TableHead>
            <TableRow>
              <TableCell className={CLASSES.header}>{title}</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(({ fieldName, type, value }) => {
              return (
                <TableRow key={fieldName}>
                  <TableCell
                    className={CLASSES.cell}
                    component="th"
                    scope="row"
                  >
                    {fieldName}
                  </TableCell>
                  <TableCell className={CLASSES.cell}>
                    {convertValueToCell(value, type)}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </Paper>
  );
};

export default DispatchSimpleTable;



// WEBPACK FOOTER //
// ./src/components/dispatches/DispatchSimpleTable.js